<template>
    <div class="viewAllLoadsWrapper">
        <main-table
            v-if="checkedArr"
            :flag="flag"
            :pageTitle='title'
            :headers="headers"
            :listItems="listItems"
            :isCreate="false"
            :isSearch="false"
            :isFilterRefresh="false"
            :is-export="false"
            isBackList
            isSend
            send
            sendText="Create statements"
            @updateSend="onSend"
            @updateBack="onBack"
            @updateClickButton="onClickButton"
        ></main-table>
    </div>
</template>
<script>
import DispatcherInfo
from "../../../../store/modules/accounting/dispatchers-statements/dispatcher-statement-create-form/dispatcher-statement-create-form.module";
import SaveDispatchersStatement from '../../../../services/accounting.services/save-dispatchers-statement.service';
import Vuex from "vuex";

// constants
import { dispatchersStatementsCreateUpHeader } from "@/constants/defaultHeader";

const store = new Vuex.Store();
store.registerModule("DispatcherInfo", DispatcherInfo);
export default {
	name: "chosen-dispatchers-statement",
	props: {
		checkedArr: Array,
		info: Array,
		permissions: Object,
		chosenDate: String,
		selectedValue: String,
	},
	mounted() {
		const sum = [];
		store.getters.getChosenDisp.map((e, index) => {
			sum.push(e.salary);
			this.dataToTable.push({ ...e, index: index + 1 });
		});
		this.totalSalary = sum.reduce((a, b) => a + b, 0);
	},
	computed: {
		headers() {
			return dispatchersStatementsCreateUpHeader;
		},
		listItems() {
			// Создаем новый массив, добавляя поле "month"
			return this.checkedArr.map(item => ({
				...item,
				month: this.selectedValue
			}));
		},
	},
	data() {
		return {
			title: 'Create Statement',
			flag: "chosenDispatchersStatement",
			totalSalary: 0,
			chosenDispatchersId: [],
			dataToTable: [],
		};
	},
	methods: {
		onBack() {
			this.$emit("backFromLoads");
		},
		onClickButton({ key, item }) {
			if (key === "openLoads") {
				this.$emit('fromChosenDispatchers', item.dispatcher_id);
			}
		},
		async onSend() {
			const ids = this.checkedArr.map(item => item.dispatcher_id);
			await SaveDispatchersStatement.saveDispatchersStatement(this.chosenDate, ids);
			this.$emit('backToMainTB');
		},

	},
};
</script>
<style lang="">
</style>
